import {Component, Input, OnInit} from '@angular/core';
import {OffersFilter} from './offers-filter/offers-filter.model';
import {FiltersDefinition} from './offers-filter/filters-definition';
import {FiltersService} from '../../../../services/filters.service';
import {isNext} from '../../../../../core/utils/utils';
import {NextFiltersDefinition} from './offers-filter/next-filters-definition';
import {InsuranceCompanyService} from '../../../../services/insurance-company.service';

@Component({
  selector: 'app-offers-filters',
  templateUrl: './offers-filters.component.html',
  styleUrls: ['./offers-filters.component.scss']
})
export class OffersFiltersComponent implements OnInit {

  @Input() embeddedInDialog: boolean;
  offersFilters: OffersFilter[];
  isNext = isNext();

  get resetButtonVisible(): boolean {
    return !this.isNext && this.filtersService.anyFiltersSelected;
  }

  constructor(public filtersService: FiltersService,
              private insuranceCompanyService: InsuranceCompanyService) {
    this.initOffersFilters();
  }

  ngOnInit() {
  }

  resetFilters(): void {
    this.filtersService.resetFilters();
  }

  private initOffersFilters(): void {
    const filtersDefinition = this.isNext ? new NextFiltersDefinition(this.insuranceCompanyService) : new FiltersDefinition(this.insuranceCompanyService);
    this.offersFilters = filtersDefinition.createConfig().filter(filter => filter.enabled !== false);
    this.filtersService.createOffersCountState(this.offersFilters);
  }

}
